export default __webpack_public_path__ + "static/media/Icon loading.bfed6900.svg";